// actionCreator.js

import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCourseTableService } from "../../../../utils/services/courses/courseService";

export const fetchCourses = createAsyncThunk(
  "/courses/fetch",
  async ({ courseName, searchTermCatgeory }) => {
    try {
      const response = await getCourseTableService({
        courseName,
        searchTermCatgeory,
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
);
